require('./accountsProductBanners.scss');

// @vendors
const React = require('react');
import { connect } from 'react-redux';
const PureRenderMixin = require('react-addons-pure-render-mixin');
const uniq = require('lodash/array/uniq');
const PropTypes = require('prop-types');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const InterestsExample = require('components/interestsExample/interestsExample');
const ProductBanner = require('components/commons/productBanner/productBanner');
const RiskProduct = require('components/riskProduct/riskProduct');
const AccountBlockedErrorModal = require('components/accounts/accountBlockedErrorModal/accountBlockedErrorModal');
import NoBannerDataError from './components/noBannerDataError';

// @ actions
const hiringProductBannersActions = require('actions/hiringProductBanners');

// @core
const { FormattedText, formatText }= require('core/i18n').i18n;

// @helpers
const { nonNumericFilter } = require('utilities/stringHelper');

// @constants
const { PROC_PACK_OPEN_YOUNG, PROC_CONTRACTS } = require('utilities/tagging');
const ACCOUNTS_PRODUCT_BANNERS = require ('constants/productBanners/accountsProductBanners');
const {
    NOT_ALLOWED_CHECKING_URLS_COUNTRIES,
    NOT_ALLOWED_PAYROLL_URLS_COUNTRIES,
    OPEN_YOUNG
} = require('constants/flagBasedFeatures.js');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @constants
const { OPEN_YOUNG_PACK_KEY } = require('constants/index.js')


class AccountsProductBanners extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showMore: false
        };

        const {
            immFlagBasedFeatures,
            isNerudaUser,
            originCountry,
            isAresUser,
            offers
        } = props;

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
        this.closeModal = this.closeModal.bind(this);

        if (isNerudaUser || isAresUser) {
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER = [
                '300', // Cuenta Corriente
                '300805', //Cuenta Corriente Nomina
            ];
        } else {
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER = [ //(nicolas.olmos): Order defined on US.
                '300805', //Cuenta Corriente Nomina
                '301', // Cuenta Ahorro
                '301101', // Cuenta Ahorro Openyoung/Junior
                OPEN_YOUNG_PACK_KEY, // Pack Open Young
                '300', // Cuenta Corriente,
            ];
        }

        if (!immFlagBasedFeatures.get(OPEN_YOUNG)) {
            const packOpenYoungIndex = this.ACCOUNTS_PRODUCT_BANNERS_ORDER.indexOf('openYoungPack');
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER.splice(packOpenYoungIndex, 1);
        }

        if (!!immFlagBasedFeatures.get(NOT_ALLOWED_CHECKING_URLS_COUNTRIES).find(country => country === originCountry)) {
            const checkingAccountIndex = this.ACCOUNTS_PRODUCT_BANNERS_ORDER.indexOf('300');
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER.splice(checkingAccountIndex, 1);
        }

        if (!!immFlagBasedFeatures.get(NOT_ALLOWED_PAYROLL_URLS_COUNTRIES).find(country => country === originCountry)) {
            const payrollAccountIndex = this.ACCOUNTS_PRODUCT_BANNERS_ORDER.indexOf('300805');
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER.splice(payrollAccountIndex, 1);
        }

        if (Object.keys(offers.offerBanner).length === 0) {
            const savingsAccountIndex = this.ACCOUNTS_PRODUCT_BANNERS_ORDER.indexOf('301');
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER.splice(savingsAccountIndex, 1);
        }
    }

    componentDidUpdate(prevProps) {
        const prevOffersBanner = prevProps.offers.offerBanner;
        const offersBanner = this.props.offers.offerBanner;

        if (Object.keys(prevOffersBanner).length === 0 && Object.keys(offersBanner).length > 0) {
            this.ACCOUNTS_PRODUCT_BANNERS_ORDER.splice(1, 0, '301');
        }
    }

    closeModal() {
        this.props.showAccountBlockedErrorModal(false);
    }

    getProductBannersOrder(userAccountAdvertisementTypes) {
        const accountTypesContractedByUser = [];
        const accountTypesNonContractedByUser = [];

        this.ACCOUNTS_PRODUCT_BANNERS_ORDER.forEach(accountType => {
            if (userAccountAdvertisementTypes.includes(accountType)) {
                accountTypesContractedByUser.push(accountType);
            } else {
                accountTypesNonContractedByUser.push(accountType);
            }
        })
    
        return accountTypesNonContractedByUser.concat(accountTypesContractedByUser);
    }

    getUserOwnedProductBannersCode = () => {
        const output = [];

        this.props.immAccounts.get('byId').forEach(immAccount => {
            const product = immAccount.get('newProduct');
            const subproduct = immAccount.get('accountType');

            if (product !== '100') { // immAccount isn't a "credito de inversion".
                const accountCodeType = nonNumericFilter(product + subproduct);
                if (accountCodeType === '300805' || accountCodeType === '301101') {
                    output.push(accountCodeType);
                } else {
                    output.push(product);
                }
            }
        });

        return uniq(output);
    }

    buildProductBanners = (orderedProductBanners) => {
        const { flagBasedFeatures, originCountry, offers, history, immOffers } = this.props;
        const allProductBanners = {
            ...ACCOUNTS_PRODUCT_BANNERS,
            ...offers.offerBanner,
        }
        return orderedProductBanners.map((bannerKey, index) => {
            const {
                advantages,
                id,
                featureTogglingKey,
                link,
                sidebarImgAlt,
                sidebarImgUrl,
                sidebarImgUrlByCountry,
                subtitle,
                title,
                onButtonClick,
                isError,
                buttonText,
                errorTertiaryText
            } = allProductBanners[bannerKey];

            const textsAlreadyTranslated = !!allProductBanners[bannerKey].textsAlreadyTranslated;
            let processType;
            let eventName;
            let eventTag;

            if (bannerKey === OPEN_YOUNG_PACK_KEY) {
                processType = PROC_PACK_OPEN_YOUNG;
            }

            /* This is only added to Cuenta Nomina, because of the intermediate screen
            to decide if you want to hire a new account or update an actual Cuenta Corriente */
            if(bannerKey === '300805') {
                processType = PROC_CONTRACTS;
                eventName = 'pre-inicio';
                eventTag = 'CUENTA NÓMINA OPEN';
            }

            const sidebarImg = (sidebarImgUrlByCountry && sidebarImgUrlByCountry[originCountry.toLowerCase()]) || sidebarImgUrl;
            if ((featureTogglingKey && flagBasedFeatures.get(featureTogglingKey) || !featureTogglingKey) && (index < this.props.amount || this.state.showMore)) {
                if (isError) {
                    return (<NoBannerDataError
                        buttonText={buttonText}
                        onClick={onButtonClick}
                        secondaryText={subtitle}
                        errorTertiaryText={errorTertiaryText}
                        primaryText={title}
                        isLoading={immOffers.get('loading')}
                        key={`accounts-product-banners-${index}`}
                    />)
                }
                return (
                    <ProductBanner
                        advantages={advantages}
                        id={id}
                        key={`accounts-product-banners-${index}`}
                        link={link}
                        eventName={eventName}
                        eventTag={eventTag}
                        processType={processType}
                        subtitle={subtitle}
                        sidebarImgAlt={sidebarImgAlt}
                        sidebarImgUrl={sidebarImg}
                        title={title}
                        textsAlreadyTranslated={textsAlreadyTranslated}
                        isAccountHiringFlow
                        linkText="productBanner-productBanner_accountsButton"
                        onButtonClickHandle={onButtonClick ? () => onButtonClick(history) : undefined}
                    />
                );
            } else {
                return null;
            }

        });
    }

    buildShowMoreButton() {
        const { isAresUser } = this.props;
        if (this.ACCOUNTS_PRODUCT_BANNERS_ORDER.length > this.props.amount && !this.state.showMore && !isAresUser) {
            const accountText = formatText('accounts-accounts');
            return (
                <div className="accounts-product-banners__show-more-button">
                    <OKButton modifier="secondary" inverse={true} onClick={this.handleShowMoreClick}>
                        <FormattedText value="productBanner-seeMore" injectedStrings={[accountText]} />
                    </OKButton>
                </div>
            )
       }
    }

    handleShowMoreClick() {
        this.setState({
            showMore: true
        });
    }

    render() {
        const { immFlagBasedFeatures, isNerudaUser, isAresUser, immHiringProductBanners, offers } = this.props;
        const userOwnedProductBannersCode = this.getUserOwnedProductBannersCode();
        const orderedProductBanners = this.getProductBannersOrder(userOwnedProductBannersCode);
        const banners = this.buildProductBanners(orderedProductBanners);
        const showMoreButton = this.buildShowMoreButton();
        let interestsExample = null;
        const showErrorModal = immHiringProductBanners.get("showErrorModal");
        let accountBlockedErrorModal = (
            <AccountBlockedErrorModal 
                description={<FormattedText value="accountBlockedErrorModal-errorDescription" />}
                handleSubmit={this.closeModal}
                showModal={showErrorModal}
                title={formatText('accountBlockedErrorModal-errorTitle')}
            />
        )

        if (!isNerudaUser && !isAresUser){
            interestsExample = <InterestsExample keyText={'productBanner-productBanner_accountsInterestsExample'} />;
        }
        const offersInterestExamples = offers.representativeExamples.map((interestExample, index) => {
            const textClassName = index + 1 < offers.representativeExamples.length 
                ? 'accounts-product-banners__offers-examples-container' 
                : 'accounts-product-banners__offers-examples-container accounts-product-banners__offers-examples-container--last-example';
            const exampleText = <div className={textClassName}>{interestExample}</div>
            return <InterestsExample key={index} keyText={exampleText} benefitSection={true} alreadyProcessedText reducedTopSpacing={index !== 0} />;
        });

        return (
            <section className="accounts-product-banners">
                <header className="accounts-product-banners__header">
                    <FormattedText value="productBanner-meetAccounts" />
                </header>
                <RiskProduct 
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    indicatorText={formatText('riskProduct-riskProduct_indicatorAccountsText')}
                />
                {banners}
                {accountBlockedErrorModal}
                {showMoreButton}
                {offersInterestExamples}
                {interestsExample}
            </section>
        );
    }
}

AccountsProductBanners.propTypes = {
    amount: PropTypes.number,
    flagBasedFeatures: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHiringProductBanners: PropTypes.object,
    isNerudaUser: PropTypes.bool.isRequired,
    offers: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
    isAresUser: PropTypes.bool.isRequired,
    showAccountBlockedErrorModal: PropTypes.func
};

module.exports = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        isNerudaUser: state.profile.get('isNerudaUser'),
        originCountry: state.profile.get('originCountry'),
        isAresUser: state.profile.get('isAresUser'),
        immHiringProductBanners: state.hiringProductBanners,
    }), {
        showAccountBlockedErrorModal: hiringProductBannersActions.showAccountBlockedErrorModal
    }
)(withFeatureToggling(AccountsProductBanners));
